import { Tag, Tooltip } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

// same status labels and tooltip as the maintenance hours (registratie.status.jsx)
const STATUS_LABEL = {
  pending: "in_aanvraag", // $t('in_aanvraag')
  approved: "geaccepteerd", // $t('geaccepteerd')
  rejected: "afgewezen", // $t('afgewezen')
};

export function DeclarationTag({ status, reviewer, reviewedAt }) {
  const tag = <Tag>{$t(STATUS_LABEL[status] || STATUS_LABEL.pending)}</Tag>;

  if (!reviewer) return tag;

  return (
    <Tooltip
      placement="top"
      title={$t("${registername} op ${registerdate}", {
        registername: reviewer,
        registerdate: reviewedAt && reviewedAt.split("T")[0],
      })}
    >
      {tag}
    </Tooltip>
  );
}
